(function () {
  const money = (value, strings) => new Intl.NumberFormat(strings.locale || 'en', { style: 'currency', currency: strings.currency || 'USD' }).format(value / 100);
  const variantKey = (values) => values.join('\u001f');
  async function start(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const strings = JSON.parse(root.querySelector('[data-builder-strings]').textContent);
    let config;
    try {
      const configUrl = JSON.parse(root.querySelector('[data-builder-config]').textContent).url;
      const response = await fetch(configUrl, { cache: 'no-store' });
      if (!response.ok) throw new Error(strings.error);
      config = await response.json();
    } catch (error) {
      root.querySelector('[data-status]').textContent = strings.error;
      delete root.dataset.ready;
      return;
    }
    root.querySelectorAll('[data-stage-photos]').forEach(holder => {
      const previewStage = config.stages.find(s => s.stage === Number(holder.dataset.stagePhotos));
      if (!previewStage) return;
      const photos = previewStage.keys.flatMap(key => {
        const component = config.components.find(c => c.key === key);
        return [...component.groups.map(g => g.choices[0]), ...(component.fixedMirror ? [component.fixedMirror] : [])];
      });
      holder.replaceChildren();
      for (const part of photos) {
        const tile = document.createElement('div'); tile.className = 'mc-builder__stage-photo' + (part.imageBranded ? ' mc-builder__stage-photo--branded' : '');
        const image = document.createElement('img'); image.src = part.image; image.alt = ''; image.loading = 'lazy'; image.width = 120; image.height = 90;
        tile.append(image); holder.append(tile);
      }
    });
    const selections = new Map();
    const add = root.querySelector('[data-add]');
    const separate = root.querySelector('[data-add-separate]');
    const status = root.querySelector('[data-status]');
    const choices = root.querySelector('[data-choices]');
    const summary = root.querySelector('[data-summary]');
    let stage = 1;
    let parts = [];
    let loading = false;
    let mirrorIncluded = true;
    const urlParams = new URLSearchParams(location.search);
    const preferredStage = Number(urlParams.get('stage'));
    if ([1, 2, 3].includes(preferredStage)) stage = preferredStage;
    const productStage = root.getAttribute('data-product-stage');
    if (productStage) stage = Number(productStage);
    function render() {
      const selectedStage = config.stages.find(s => s.stage === stage);
      parts = selectedStage.keys.map(key => config.components.find(p => p.key === key));
      choices.replaceChildren();
      status.textContent = '';
      root.querySelectorAll('[data-stage]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.stage) === stage)));
      for (const component of parts) {
        for (const group of component.groups) {
          const saved = selections.get(group.name);
          const current = group.choices.find(c => c.label === saved) || group.choices[0];
          selections.set(group.name, current.label);
          const card = document.createElement('div'); card.className = 'mc-builder__choice';
          const photo = document.createElement('div'); photo.className = 'mc-builder__photo' + (current.imageBranded ? ' mc-builder__photo--branded' : '');
          const image = document.createElement('img'); image.loading = 'lazy'; image.width = 420; image.height = 240; image.src = current.image; image.alt = current.label;
          const link = document.createElement('a'); link.className = 'mc-builder__separate'; link.textContent = strings.buy_separately; link.href = current.productUrl; link.dataset.partLink = group.name;
          photo.append(image);
          const id = root.id + '-' + group.name.toLowerCase().replace(/\W+/g, '-');
          const label = document.createElement('label'); label.htmlFor = id; label.textContent = strings.groups[group.name] || group.name;
          const select = document.createElement('select'); select.id = id; select.dataset.group = group.name;
          for (const choice of group.choices) {
            const option = document.createElement('option'); option.value = choice.label; option.textContent = choice.label + ' · ' + money(choice.price, strings); option.selected = choice.label === current.label; select.append(option);
          }
          select.addEventListener('change', () => { selections.set(group.name, select.value); const next = group.choices.find(c => c.label === select.value); image.src = next.image; image.alt = next.label; photo.classList.toggle('mc-builder__photo--branded', !!next.imageBranded); link.href = next.productUrl; update(); });
          card.append(photo, label, select, link); choices.append(card);
        }
        if (component.fixedMirror) {
          const mirror = component.fixedMirror;
          const card = document.createElement('div'); card.className = 'mc-builder__choice';
          const photo = document.createElement('div'); photo.className = 'mc-builder__photo';
          const image = document.createElement('img'); image.loading = 'lazy'; image.width = 420; image.height = 240; image.src = mirror.image; image.alt = mirror.label; photo.append(image);
          const included = document.createElement('p'); included.className = 'mc-builder__included'; included.textContent = strings.included_in_stage3;
          const label = document.createElement('label'); label.className = 'mc-builder__fixed'; label.textContent = mirror.label;
          const select = document.createElement('select'); select.id = root.id + '-mirror-caps'; select.dataset.mirrorChoice = '';
          label.htmlFor = select.id;
          component.mirrorValues.forEach((value, index) => { const option = document.createElement('option'); option.value = value; option.textContent = index === 0 ? strings.mirror_include_choice : strings.mirror_exclude_choice; option.selected = index === (mirrorIncluded ? 0 : 1); select.append(option); });
          select.addEventListener('change', () => { mirrorIncluded = select.value === component.mirrorValues[0]; update(); });
          const note = document.createElement('p'); note.className = 'mc-builder__included-note'; note.textContent = strings.included_note;
          const link = document.createElement('a'); link.className = 'mc-builder__separate'; link.textContent = strings.mirror_standalone; link.href = mirror.productUrl; link.dataset.partLink = 'MIRROR CAPS';
          card.dataset.mirrorCard = ''; included.dataset.mirrorBadge = ''; note.dataset.mirrorNote = '';
          note.id = select.id + '-note'; select.setAttribute('aria-describedby', note.id);
          card.append(photo,included,label,select,note,link); choices.append(card);
        }
      }
      update();
    }
    function getBuild() {
      const items = [];
      const individualItems = [];
      let total = 0;
      let retail = 0;
      const lines = [];
      for (const component of parts) {
        const selected = component.groups.map(g => g.choices.find(c => c.label === selections.get(g.name)));
        if (selected.some(c => !c)) return null;
        const values = selected.map(c => c.label);
        if (component.mirrorOptional) values.push(component.mirrorValues[mirrorIncluded ? 0 : 1]);
        const variant = component.variants[variantKey(values)];
        if (!variant) return null;
        const properties = { Vehicle: config.fitment, Package: strings.stage + ' ' + stage };
        selected.forEach((c, i) => { const name = strings.groups[component.groups[i].name] || component.groups[i].name; properties[name] = c.label; lines.push([name, c.label]); retail += c.price; });
        selected.forEach(c => individualItems.push({id:c.variantId, quantity:1}));
        if (component.fixedMirror) {
          const include = !component.mirrorOptional || mirrorIncluded;
          properties[strings.mirror] = include ? component.fixedMirror.label : component.mirrorValues[1];
          lines.push([strings.mirror, include ? component.fixedMirror.label + ' · ' + strings.included_short : strings.mirror_exclude_choice]);
          if (include) { retail += component.fixedMirror.price; individualItems.push({id:component.fixedMirror.variantId, quantity:1}); }
        }
        items.push({ id: variant.id, quantity: 1, properties });
        total += variant.price;
      }
      return { items, individualItems, total, retail, lines };
    }
    function update() {
      const build = getBuild();
      const mirrorCard = root.querySelector('[data-mirror-card]');
      if (mirrorCard) {
        const finish = parts.find(c => c.mirrorOptional);
        const selected = finish.groups.map(g => selections.get(g.name));
        const withMirror = finish.variants[variantKey([...selected, finish.mirrorValues[0]])];
        const withoutMirror = finish.variants[variantKey([...selected, finish.mirrorValues[1]])];
        const select = mirrorCard.querySelector('[data-mirror-choice]');
        select.options[1].textContent = strings.mirror_exclude_choice + ' · ' + strings.mirror_reduce_total + ' ' + money(withMirror.price - withoutMirror.price, strings);
        mirrorCard.querySelector('[data-mirror-badge]').textContent = mirrorIncluded ? strings.included_in_stage3 : strings.mirror_not_included;
        mirrorCard.querySelector('[data-mirror-badge]').classList.toggle('mc-builder__included--excluded', !mirrorIncluded);
        mirrorCard.querySelector('[data-mirror-note]').textContent = mirrorIncluded ? strings.included_note : strings.mirror_removed_note;
        mirrorCard.querySelector('.mc-builder__photo').classList.toggle('mc-builder__photo--excluded', !mirrorIncluded);
      }
      summary.replaceChildren();
      if (!build) { add.disabled = true; if(separate)separate.disabled=true; status.textContent = strings.unavailable; return; }
      for (const [name, value] of build.lines) { const dt = document.createElement('dt'); dt.textContent = name; const dd = document.createElement('dd'); dd.textContent = value; summary.append(dt, dd); }
      root.querySelector('[data-retail]').textContent = money(build.retail, strings);
      root.querySelector('[data-total]').textContent = money(build.total, strings);
      root.querySelector('[data-saving]').textContent = strings.saving + ' ' + money(build.retail - build.total, strings) + ' (' + config.stages.find(s => s.stage === stage).discount + '%)';
      add.disabled = loading;
      if(separate){separate.disabled=loading;separate.textContent=strings.add_separate+' · '+money(build.retail,strings);}
    }
    root.querySelectorAll('[data-stage]').forEach(b => b.addEventListener('click', () => { if (loading) return; stage = Number(b.dataset.stage); render(); }));
    async function addBuild(asIndividual) {
      const build = getBuild(); if (!build || loading) return;
      loading = true; add.disabled = true; add.textContent = strings.adding; status.textContent = '';
      try {
        const routesRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(routesRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: asIndividual ? build.individualItems : build.items }) });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || strings.error);
        location.assign(routesRoot + 'cart');
      } catch (error) { status.textContent = error.message || strings.error; loading = false; add.textContent = strings.add; update(); }
    }
    add.addEventListener('click', () => addBuild(false));
    if(separate)separate.addEventListener('click', () => addBuild(true));
    render();
  }
  document.querySelectorAll('[data-mc-builder]').forEach(start);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-mc-builder]').forEach(start));
})();


